<template>
    <div class="detail">
      <div class="qr_code">
        <img :src="qr_code" alt="">
        <div class="tips">
          <p class="p1">{{tips}}</p>
        </div>
      </div>
      <div class="Msg">
        <div v-for="(item,index) in message" :key="index" class="message" :style="{display: (disable[item.key]===undefined)||(disable[item.key]!==undefined&&onePersonData.idCardType !== '居民身份证') ? 'display' : 'none'}">
          <span v-if="(disable[item.key]===undefined)||(disable[item.key]!==undefined&&onePersonData.idCardType !== '居民身份证')" class="name">{{item.name}}:</span>
          <span v-if="(disable[item.key]===undefined)||(disable[item.key]!==undefined&&onePersonData.idCardType !== '居民身份证')" class="key">{{onePersonData[item.key]}}</span>
        </div>
      </div>
      <div class="buttons">
        <el-button type="info" size="small" style="width: 40%" @click="deletePersonMessage">{{deleteMsg}}</el-button>
        <el-button type="primary" size="small" style="width: 40%" @click="toAdd">{{addMsg}}</el-button>
      </div>
    </div>
</template>

<script>
  import  storage from '../../model/storage.js'
    export default {
      name: "codePage",
      data() {
        return{
          type: storage.get('type'),
          tips: '请截屏或长按图片保存二维码图片，以便出示给工作人员扫描',
          countrySelects: {
            'China': '中国',
            'Hong Kong China': '中国香港',
            'Macao, China':'中国澳门',
            'Taiwan, China': '中国台湾',
            'South Korea': '韩国',
            'Japan': '日本',
            'Italy': '意大利',
            'Spain': '西班牙',
            'France':'法国',
            'Germany': '德国',
            'U.S': '美国',
            'Canada':'加拿大',
            'Singapore': '新加坡',
            'Malaysia':'马来西亚',
            'Bahrain': '巴林',
            'UAE': '阿联酋',
            'Switzerland': '瑞士',
            'Netherlands': '荷兰',
            'UK':'英国',
            'Sweden':'瑞典',
            'Australia': '澳大利亚',
            'new Zealand': '新西兰',
            'Brazil':'巴西',
            'Argentina': '阿根廷',
            'Iran':'伊朗',
            'Afghanistan': '阿富汗',
            'Albania': '阿尔巴尼亚',
            'Antarctica':'南极洲',
            'Algeria': '阿尔及利亚',
            'American Samoa':'美属萨摩亚',
            'Andorra': '安道尔',
            'Angola':'安哥拉',
            'Antigua and Barbuda': '安提瓜和巴布达',
            'Azerbaijan':'阿塞拜疆',
            'Austria': '奥地利',
            'Bahamas': '巴哈马',
            'Bangladesh':'孟加拉国',
            'Armenia': '亚美尼亚',
            'Palestine': '巴勒斯坦',
            'Barbados':'巴巴多斯',
            'Belgium': '比利时',
            'Bermuda': '百慕大',
            'Bhutan':'不丹',
            'Bolivia': '玻利维亚',
            'Bosnia and Herzegovina':'波黑',
            'Botswana':'博茨瓦纳',
            'Bouvet Island': '布维岛',
            'Belize':'伯利兹',
            'British Indian Ocean Territory':'英属印度洋领地',
            'Solomon Islands': '所罗门群岛',
            'The British Virgin Islands':'英属维尔京群岛',
            'Brunei':'文莱',
            'Bulgaria':'保加利亚',
            'Myanmar': '缅甸',
            'Burundi': '布隆迪',
            'Belarus': '白俄罗斯',
            'Cambodia':'柬埔寨',
            'Cameroon':'喀麦隆',
            'Cape Verde':'佛得角',
            'Cayman Islands':'开曼群岛',
            'Central Africa':'中非',
            'Sri Lanka': '斯里兰卡',
            'Chad':'乍得',
            'Chile': '智利',
            'Christmas Island':'圣诞岛',
            'Cocoskill Islands': '科科斯（基林）群岛',
            'Colombia':'哥伦比亚',
            'Comoros': '科摩罗',
            'Mayotte': '马约特',
            'Republic of Congo': '刚果（布）',
            'Congo': '刚果（金）',
            'Island':'库克群岛',
            'Costa Rica':'哥斯达黎加',
            'Croatia': '克罗地亚',
            'Cuba':'古巴',
            'Cyprus':'塞浦路斯',
            'Czech Republic':'捷克',
            'Benin': '贝宁',
            'Denmark': '丹麦',
            'Dominic':'多米尼克',
            'Dominica':'多米尼加',
            'Ecuador': '厄瓜多尔',
            'Salvador':'萨尔瓦多',
            'Equatorial Guinea': '赤道几内亚',
            'Ethiopia':'埃塞俄比亚',
            'Eritrea': '厄立特里亚',
            'Estonia': '爱沙尼亚',
            'Faroe Islands': '法罗群岛',
            'Malvinas, Falkland Islands':'福克兰群岛（马尔维纳斯群岛）',
            'South Georgia and South Sandwich Island': '南乔治亚岛和南桑德韦奇岛',
            'Fiji':'斐济',
            'Finland': '芬兰',
            'Aland Islands': '奥兰群岛',
            'French Guiana': '法属圭亚那',
            'French Polynesia':'法属波利尼西亚',
            'French Southern Territory': '法属南部领地',
            'Djibouti':'吉布提',
            'Gabon': '加蓬',
            'Georgia': '格鲁吉亚',
            'Gambia':'冈比亚',
            'Ghana': '加纳',
            'Gibraltar': '直布罗陀',
            'Kiribati':'基里巴斯',
            'Greece':'希腊',
            'Greenland': '格陵兰',
            'Grenada': '格林纳达',
            'Guadeloupe':'瓜德罗普',
            'Guam':'关岛',
            'Guatemala': '危地马拉',
            'Guinea':'几内亚',
            'Guyana':'圭亚那',
            'Haiti': '海地',
            'Heard Island and McDonald Island':'赫德岛和麦克唐纳岛',
            'Vatican': '梵蒂冈',
            'Honduras':'洪都拉斯',
            'Hungary': '匈牙利',
            'Iceland': '冰岛',
            'India': '印度',
            'Indonesia': '印度尼西亚',
            'Iraq':'伊拉克',
            'Ireland': '爱尔兰',
            'Israel':'以色列',
            "Cote d'Ivoire": '科特迪瓦',
            'Jamaica': '牙买加',
            'Kazakhstan':'哈萨克斯坦',
            'Jordan':'约旦',
            'Kenya': '肯尼亚',
            'North Korea': '朝鲜',
            'Kuwait':'科威特',
            'Kyrgyzstan':'吉尔吉斯斯坦',
            'Laos':'老挝',
            'Lebanon': '黎巴嫩',
            'Lesotho': '莱索托',
            'Latvia':'拉脱维亚',
            'Liberia': '利比里亚',
            'Libya': '利比亚',
            'Liechtenstein': '列支敦士登',
            'Lithuania': '立陶宛',
            'Luxembourg':'卢森堡',
            'Madagascar':'马达加斯加',
            'Malawi':'马拉维',
            'Maldives':'马尔代夫',
            'Mali':'马里',
            'Malta': '马耳他',
            'Martinique':'马提尼克',
            'Mauritania':'毛里塔尼亚',
            'Mauritius': '毛里求斯',
            'Mexico':'墨西哥',
            'Monaco':'摩纳哥',
            'Mongolia':'蒙古',
            'Moldova': '摩尔多瓦',
            'Montenegro':'黑山',
            'Montserrat':'蒙特塞拉特',
            'Morocco': '摩洛哥',
            'Mozambique':'莫桑比克',
            'Oman':'阿曼',
            'Namibia': '纳米比亚',
            'Nauru': '瑙鲁',
            'Nepal': '尼泊尔',
            'Netherlands Antilles':'荷属安的列斯',
            'Aruba': '阿鲁巴',
            'New Caledonia': '新喀里多尼亚',
            'Vanuatu': '瓦努阿图',
            'Nicaragua': '尼加拉瓜',
            'Niger': '尼日尔',
            'Nigeria': '尼日利亚',
            'Niue':'纽埃',
            'Norfolk Island':'诺福克岛',
            'Norway':'挪威',
            'Northern Mariana':'北马里亚纳',
            'U.S. Minor Outlying Islands': '美国本土外小岛屿',
            'Micronesia':'密克罗尼西亚',
            'Marshall Islands':'马绍尔群岛',
            'Palau': '帕劳',
            'Pakistan':'巴基斯坦',
            'Panama':'巴拿马',
            'Papua New Guinea':'巴布亚新几内亚',
            'Paraguay':'巴拉圭',
            'Peru':'秘鲁',
            'Philippine':'菲律宾',
            'Pitcairn Islands':'皮特凯恩群岛',
            'Poland':'波兰',
            'Portugal':'葡萄牙',
            'Guinea-Bissau': '几内亚比绍',
            'East Timor':'东帝汶',
            'Puerto Rico': '波多黎各',
            'Qatar': '卡塔尔',
            'Reunion': '留尼汪',
            'Romania': '罗马尼亚',
            'Russia':'俄罗斯',
            'Rwanda':'卢旺达',
            'St. Helena':'圣赫勒拿',
            'Saint Kitts and Nevis': '圣基茨和尼维斯',
            'Anguilla':'安圭拉',
            'Saint Lucia': '圣卢西亚',
            'Saint Pierre and Miquelon': '圣皮埃尔和密克隆',
            'Saint Vincent and the Grenadines':'圣文森特和格林纳丁斯',
            'San Marino':'圣马力诺',
            'Sao Tome and Principe': '圣多美和普林西比',
            'Saudi Arabia':'沙特阿拉伯',
            'Senegal': '塞内加尔',
            'Serbia':'塞尔维亚',
            'Seychelles':'塞舌尔',
            'Sierra Leone':'塞拉利昂',
            'Slovakia':'斯洛伐克',
            'Vietnam': '越南',
            'Slovenia':'斯洛文尼亚',
            'Somalia': '索马里',
            'South Africa':'南非',
            'Zimbabwe':'津巴布韦',
            'Western Sahara':'西撒哈拉',
            'Sudan': '苏丹',
            'Suriname':'苏里南',
            'Svalbard and Jan Mayen':'斯瓦尔巴岛和扬马延岛',
            'Swaziland': '斯威士兰',
            'Syria': '叙利亚',
            'Tajikistan':'塔吉克斯坦',
            'Thailand':'泰国',
            'Togo':'多哥',
            'Tokelau': '托克劳',
            'Tonga': '汤加',
            'Trinidad and Tobago': '特立尼达和多巴哥',
            'Tunisia': '突尼斯',
            'Turkey':'土耳其',
            'Turkmenistan':'土库曼斯坦',
            'Turks and Caicos Islands':'特克斯和凯科斯群岛',
            'Tuvalu':'图瓦卢',
            'Uganda':'乌干达',
            'Ukraine': '乌克兰',
            'North Macedonia': '北马其顿',
            'Egypt': '埃及',
            'Guernsey':'格恩西岛',
            'Jersey':'泽西岛',
            'Isle of Man': '英国属地曼岛',
            'Tanzania':'坦桑尼亚',
            'United States Virgin Islands':'美属维尔京群岛',
            'Burkina Faso':'布基纳法索',
            'Uruguay': '乌拉圭',
            'Uzbekistan':'乌兹别克斯坦',
            'Venezuela': '委内瑞拉',
            'Varis and Futuna':'瓦里斯和福图纳',
            'Samoa': '萨摩亚',
            'Yemen': '也门',
            'Zambia':'赞比亚'
          },
          message: [
            {
              name: '姓名',
              key: 'userName'
            },
            {
              name: '证件类型',
              key: 'idCardType'
            },
            {
              name: '证件号码',
              key: 'idCard'
            },
            {
              name: '国籍',
              key: 'country'
            },



            {
              name: '性别',
              key: 'sexRadio'
            },
            // {
            //   name: '年龄',
            //   key: 'age'
            // },
            {
              name: '出生日期',
              key: 'birthday'
            },
            {
              name: '手机号',
              key: 'phone'
            },

            // {
            //   name: '单位名称',
            //   key: 'Residence'
            // },
            {
              name: '备注',
              key: 'remarks'
            },
          ],
          qr_code: '',
          onePersonData: {},
          disable:{
            'age':true,
            'country':true,
            'birthday':true,
            'sex':true,
          },
          deleteMsg: '删除信息',
          addMsg: '+ 添加其他人'

        }
      },
      created() {
        console.log(this.type)
        if (this.type === 'English') {
          this.message = [
            {
              name: 'Name',
              key: 'userName'
            },
            {
              name: 'Certificates type',
              key: 'idCardType'
            },
            {
              name: 'Passport No.',
              key: 'idCard'
            },
            {
              name: 'Nationality',
              key: 'country'
            },



            {
              name: 'Gender',
              key: 'sexRadio'
            },
            // {
            //   name: '年龄',
            //   key: 'age'
            // },
            {
              name: 'Birthdate',
              key: 'birthday'
            },
            {
              name: 'Contact No.',
              key: 'phone'
            },

            // {
            //   name: '单位名称',
            //   key: 'Residence'
            // },
            {
              name: 'Remarks',
              key: 'remarks'
            },
          ]
          this.tips = 'Please take a screenshot or long press the picture to save the QR code picture so as to show it to the staff for scanning'
          this.deleteMsg = 'delete'
          this.addMsg = 'add others'
        }
        let userData = storage.get('puchaUserData')
        console.log(userData)
        let index = this.$route.query.index
        if (index === undefined) {
          this.$message('网络错误')
          return
        }
        this.onePersonData = userData[index]
        console.log(this.onePersonData)
        let type = 'xaindex'
        let info = this.onePersonData.userName + '_cha_'
                  + this.onePersonData.idCardType + '_cha_'
                  + this.onePersonData.idCard + '_cha_'
                  + this.onePersonData.sexRadio + '_cha_'
                  + this.onePersonData.age + '_cha_'
                  + this.onePersonData.phone + '_cha_'
                  + '_cha_'
                  + this.onePersonData.country + '_cha_'
                  + this.onePersonData.remarks + '_cha_'
                  + this.onePersonData.personType + '_cha_'
                  + this.onePersonData.Residence + '_cha_'
                  + this.onePersonData.birthday


        info = this.base64_encode(encodeURI(info))
        // let url = 'https://wx.hezijiyin.com/api/'
        // let url = 'http://admin.hezihuaxi.com/public/api.php/'
        let url = domain.baseUrl
        this.qr_code = url + 'report/index/geturl/type/'+type+"/info/" + info
        console.log(this.qr_code)
        if (this.type === 'English') {
          // 国籍中英文对应
          for (let item in this.countrySelects) {
            if(this.onePersonData.country === this.countrySelects[item]) {
              this.onePersonData.country = item
            }
          }
          // 证件类型（护照）中英文对应
          if (this.onePersonData.idCardType === '护照') {
            this.onePersonData.idCardType = 'passport'
          }
          // 性别中英文对应
          if (this.onePersonData.sexRadio === '男') {
            this.onePersonData.sexRadio = 'Male'
          }
          if(this.onePersonData.sexRadio === '女'){
            this.onePersonData.sexRadio = 'Female'
          }
          console.log(this.onePersonData)
        }
      },
      methods: {
        base64_encode(str) {
          var c1, c2, c3;
          var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          var i = 0, len = str.length, string = '';

          while (i < len) {
            c1 = str.charCodeAt(i++) & 0xff;
            if (i == len) {
              string += base64EncodeChars.charAt(c1 >> 2);
              string += base64EncodeChars.charAt((c1 & 0x3) << 4);
              string += "==";
              break;
            }
            c2 = str.charCodeAt(i++);
            if (i == len) {
              string += base64EncodeChars.charAt(c1 >> 2);
              string += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
              string += base64EncodeChars.charAt((c2 & 0xF) << 2);
              string += "=";
              break;
            }
            c3 = str.charCodeAt(i++);
            string += base64EncodeChars.charAt(c1 >> 2);
            string += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
            string += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
            string += base64EncodeChars.charAt(c3 & 0x3F)
          }
          return string
        },
        toAdd() {
          if (this.type === 'English') {
            this.$router.push({
              path: '/pucha_eng',
              name: 'puchaEngForm',
              query: {
                on: 1,
              }
            })
          }else {
            this.$router.push({
              path: '/pucha',
              name: 'puchaFormIndex',
              query: {
                on: 1,
              }
            })
          }

        },
        deletePersonMessage() {
          let index = this.$route.query.index
          let userData = storage.get('puchaUserData')
          userData.splice(index,1)
          storage.set('puchaUserData',userData)
          let newUserDaTa = storage.get('puchaUserData')
          console.log(userData.length)
          console.log(newUserDaTa.length)
            this.$router.push({
              path: '/pucha_list',
              name: 'puchaList',
            })


        }
      }
    }
</script>

<style scoped>
  .qr_code{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .qr_code img{
    width: 280px;
    height: 280px;
  }
  .tips{
    margin-top: -20px;
    color: #c1bfbf;
    font-size: 15px;
    width: 80%;
  }
  .tips .p2 {
    margin-top: -18px;
  }
  .Msg {
    min-height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .message {
    display: flex;
    flex-direction: row;
    align-content: center;
    /*margin-left: 10px;*/
    padding: 5px 10px;
    border-bottom: 1px solid #e6e6e6;
    height: auto;
    line-height: normal;
    width: 90%;

  }
  .name {
    text-align: left;
    width: 30%;
    white-space: nowrap;
  }

  .key {
    text-align: right;
    width: 70%;
    margin: auto 0 auto 10px;

  }
  .buttons {
    position: relative;
    bottom: 10px;
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/pucha/puchaCodePage.vue